<!--首页-->
<template>
  <div class="home-box cr">
    <!-- <div class="newhead-box flex" @click="handleJump3()">
      <img :src="`编组21.png` | fullImageUrl" />
    </div> -->
    <div class="my-works">
      <div class="select-box">
        <div class="flex ac">
          <div class="flex ac">
            <div class="pp1" @click="handleChoose(1)">
              我的作品 · {{ workList.length }}
            </div>
          </div>
          <div style="margin-left: 10px">
            <el-input placeholder="请输入名称搜索" v-model="selectObj.name">
              <el-button
                slot="append"
                icon="el-icon-search"
                style="color: #f7d274"
                @click="select()"
              ></el-button>
            </el-input>
          </div>
        </div>
        <div>
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane
              :label="item.label"
              :name="item.value"
              v-for="(item, index) in options"
              :key="index"
            ></el-tab-pane>
          </el-tabs>
        </div>
      </div>

      <div>
        <div class="flex ac fw">
          <!-- 换成使用图片字段 -->
          <!-- <div
            class="every-video-s"
            @mouseover="handleMouse(item)"
            @mouseleave="handleMouseOut"
            @click="handlePlay(item)"
            v-for="(item, index) in workList"
            :key="index"
            :style="{
              backgroundImage: 'url(' + item.cover + ')',
              backgroundRepeat: 'no-repeat',
            }"
          > -->
          <!-- 换成获取视频第一帧 -->
          <div
            class="every-video-s"
            @mouseover="handleMouse(item)"
            @mouseleave="handleMouseOut"
            @click="handlePlay(item)"
            v-for="(item, index) in workList"
            :key="index"
            :style="{
              backgroundImage:
                'url(' +
                item.oss_url +
                '?x-oss-process=video/snapshot,t_1000,f_jpg,w_0,h_0,m_fast,ar_auto' +
                ')',
              backgroundRepeat: 'no-repeat',
            }"
          >
                  
          <div class="api-num1" v-if="item.video_channel_name">
              {{ item.video_channel_name }}
            </div>
            <div
              class="api-num1"
              v-if="!item.video_channel_name && getName(item.api_key2)"
            >
              {{ getName(item.api_key2) ? getName(item.api_key2) : "" }}
            </div>
            <!-- <img :src="item.cover" alt="cover" @click="handlePlay(item)" /> -->
            <!-- <p class="pp3 fs15 te">{{ item.name }}</p> -->
            <div class="flex ac jb video-hover">
              <div>
                <!-- <div class="" @click="handlePlay(item)">播放视频</div>
                <div class="" @click="handleJump3(item)">+ 创建视频</div> -->
                <div class="te viode-hover-name">{{ item.name }}</div>
                <div class="te viode-hover-time">{{ item.create_time }}</div>
              </div>
              <div class="video-pop">
                <el-popover
                  ref="popoverRef"
                  placement="top"
                  trigger="hover"
                  v-model="item.visible"
                  width="1"
                >
                  <template>
                    <div class="video-pop-select cr">
                      <div class="select-1" @click="handleReName(item)">
                        重命名
                      </div>
                      <div class="select-2" @click="downVideo(item)">下载</div>
                      <div class="select-3" @click="handleDelete(item)">
                        删除
                      </div>
                    </div>
                  </template>
                  <template slot="reference">
                    <div class="">
                      <img src="../assets/ccc/编组11png.png" />
                    </div>
                  </template>
                </el-popover>
              </div>
            </div>
            <div
              class="shengchenging"
              v-if="item.status != 3 && item.status !== 4"
            >
              <!-- -->

              <div class="desc-pp" v-if="item.api_key == 'ou'">
                <p>排队训练中</p>
                <p>对效果及训练时长不满意</p>
                <p>可以选择更高等级通道训练</p>
              </div>

              <div class="desc-pp" v-else-if="item.api_key == 'gj'">
                <p>免费排队训练中</p>
                <p>时间无法确定预测</p>
                <p>可以选择更高等级通道训练</p>
              </div>
              <div class="desc-pp" v-else-if="item.api_key == 'df'">
                <p>极速训练中3~5分钟</p>
                <p>如对生成效果不满意</p>
                <p>可选择更高等级训练</p>
              </div>
              <div class="desc-pp" v-else-if="item.api_key == 'fy'">
                <p>深度训练中</p>
                <p>6~10分钟请耐心等待</p>
              </div>
              <div class="desc-pp" v-else>
                <p>正在为您训练中</p>
                <p>请耐心等待</p>
              </div>
              <!-- <img
                src="https://xcyq.oss-cn-qingdao.aliyuncs.com/weChatApp/loadingGif2.gif"
                alt="gif"
              /> -->
              <img :src="`uploadingGif.gif` | fullImageUrl" alt="gif" />
            </div>
            <div class="shengchenging" v-if="item.status == 4">
              <div class="desc-pp">
                <p>生成失败，重新生成</p>
                <p>或选择更高等级训练</p>
              </div>
            </div>
          </div>
          <div v-if="workList.length <= 0" class="no-info-box tc">
            <img :src="`编组27.png` | fullImageUrl" alt="i" />
            <p>
              暂无内容

              <!-- ，<span @click="handleJump3()">点我立即创建视频</span> -->
            </p>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="重命名"
      :visible.sync="dialogVisible3"
      width="25%"
      top="35vh"
    >
      <el-input v-model="name" placeholder="请输入名字" style="width: 100%" />
      <span slot="footer" class="dialog-footer">
        <el-button type="info" @click="dialogVisible3 = false">取 消</el-button>
        <el-button type="primary" @click="sumbitName">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="视频下载进度"
      :visible.sync="dialogVisible4"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="25%"
      top="35vh"
    >
      <div>
        <el-progress :percentage="progress"></el-progress>
      </div>
    </el-dialog>
    <el-dialog
      :title="videoName"
      :visible.sync="dialogVisible"
      width="50%"
      @close="handleDialogClose"
    >
      <div class="dialog-video">
        <video
          ref="videoPlayer"
          style="width: 100%; height: 100%"
          controls=""
          autoplay=""
          :src="videoUrl"
        ></video>
      </div>
    </el-dialog>
  </div>
</template>
  <script>
import { getWorks, postWorks, delWorks,gVideoChannel } from "../api/user";

export default {
  name: "",
  data() {
    return {
      options: [
        {
          value: "0",
          label: "全部",
        },
        {
          value: "2",
          label: "生成中",
        },
        {
          value: "3",
          label: "生成成功",
        },
        {
          value: "4",
          label: "生成失败",
        },
      ],
      activeName: 0,
      input1: "",
      selectObj: {
        page: 1,
        limit: 9999,
        name: "",
        status: "",
      },
      popoverVisible: null,
      workList: [],
      dialogVisible3: null,
      dialogVisible: null,
      name: "",
      myOneVoice: {},
      videoId: "",
      videoName: "",
      videoUrl: "",
      dialogVisible4: false,
      progress: 0,
      videoChannelList:[]
    };
  },
  created() {
    this.getWorksList();
    this.getgVideoChannel();
  },
  methods: {
    // 获取通道的名字
    getName(api) {
      console.log("222000000", api);
      if (this.videoChannelList.length > 0) {
        for (let i = 0; i < this.videoChannelList.length; i++) {
          if (this.videoChannelList[i].api == api) {
            return this.videoChannelList[i].name;
            break;
          }
        }
      }
    },
    getgVideoChannel() {
      gVideoChannel().then((res) => {
        this.videoChannelList = res.data.list;
      });
    },
    // 下载视频
    downVideo(item) {
      const that = this;
      var xhr = new XMLHttpRequest();
      xhr.open("GET", item.url, true);
      // xhr.open('GET', require('../../assets/images/test.mp4'), true)
      xhr.responseType = "blob"; // 返回类型blob
      // 监听进度
      that.dialogVisible4 = true;
      that.progress = 0;
      xhr.onprogress = function (e) {
        // console.log('e',e)
        if (e.lengthComputable) {
          // 文件总体积
          // console.log(e.total)
          // 已下载体积
          // console.log(e.loaded)
          var percentComplete = 0;
          var percentComplete = (e.loaded / e.total) * 100;
          // console.log('percentComplete', percentComplete)
          that.progress = Math.floor(percentComplete);
        }
      };
      xhr.onload = function () {
        // this.show = false
        if (xhr.readyState === 4 && xhr.status === 200) {
          console.log("开始下载");
          // that.$message.success('开始下载，稍候在下载文件中查找！')
          const blob = this.response;
          // console.log('blob',blob)
          // 转换一个blob链接
          const u = window.URL.createObjectURL(new Blob([blob]));
          const a = document.createElement("a");
          // a.download = '1344.mp4'
          var str = "";
          // str = new Date().getTime() + '.mp4'
          str = item.name + ".mp4";
          a.download = str;
          a.href = u;
          // console.log('下载名取好')
          // a.style.display = 'none'
          document.body.appendChild(a);
          a.click();
          // a.remove();
          // 释放
          console.log("结束");
          that.dialogVisible4 = false;
          that.$message.success("下载成功！");
          window.URL.revokeObjectURL(u);
        } else {
          console.log("失败了");
          that.dialogVisible4 = false;
          that.$message.error("下载失败！");
        }
      };
      xhr.onerror = function () {
        console.log("下载失败");
        that.dialogVisible4 = false;
        that.$message.error("下载失败！");
      };
      xhr.send();
    },
    handleDialogClose() {
      // 停止视频播放
      if (this.$refs.videoPlayer) {
        this.$refs.videoPlayer.pause();
      }
      // 重置视频源
      // this.videoSrc = '';
    },
    handlePlay(item) {
      this.videoName = item.name;
      this.videoUrl = item.url;
      console.log("222", this.videoUrl);

      this.videoId = item.id;
      this.dialogVisible = true;
    },
    handleClick(tab) {
      console.log(tab.name);
      this.selectObj.status = tab.name;
      this.getWorksList();
    },
    handleDelete(item) {
      this.$confirm("此操作将永久删除该作品, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delWorks({ id: item.id }).then(() => {
            this.getWorksList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleDown(item) {
      const url = item.url;
      const filename = item.name + ".mp3";
      const element = document.createElement("a");
      element.href = url;
      element.download = filename;
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    },
    handleReName(item) {
      this.dialogVisible3 = true;
      this.myOneVoice = item;
    },
    sumbitName() {
      if (this.myOneVoice.id) {
        if (!this.name) {
          this.$message.error("请填写名称后保存");
        } else {
          postWorks({ id: this.myOneVoice.id, name: this.name })
            .then((res) => {
              this.dialogVisible3 = false;
              this.name = "";
              this.myOneVoice = {};
              this.getWorksList();
            })
            .catch((error) => {
              this.$message.error(error.msg);
            });
        }
      }
    },
    hideaaaaa(e) {
      console.log("我隐藏了", e);
    },
    showaaaaa(e) {
      console.log("我显示了", e);
    },
    goBeian() {
      window.open("https://beian.miit.gov.cn/", "_blank");
    },
    handleChoose(val) {
      this.titleState = val;
    },
    handleHs(val) {
      this.hsState = val;
      this.getWorksList();
    },
    handleMouse(item) {
      this.hoverId = item.id;
    },
    select() {
      this.getWorksList();
    },
    handleMouseOut() {
      this.hoverId = "";
    },
    handleJump(val) {
      this.$router.push(val);
    },
    handleJump3() {
      this.$router.push({
        path: "/create",
      });
    },
    getWorksList() {
      getWorks({ ...this.selectObj }).then((res) => {
        console.log("video=======", res);
        this.workList = res.data.list;
      });
    },
  },
  /**加载完组件时执行(加载完成之后执行)*/
  mounted() {},
};
</script>
  
  <style scoped lang="scss">
.no-info-box {
  margin: 50px auto;
  color: #ffffffaa;
  img {
    width: 134px;
    height: 104px;
  }
  p {
    font-weight: 400;
    font-size: 13px;
    color: rgba(255, 255, 255, 0.7);
  }
}
.dialog-video {
  width: 100%;
  height: 440px;
}
.video-pop-select {
  height: 118px;
  // background: #121212;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.88);
  .select-1 {
  }
  .select-2 {
  }
  .select-3 {
  }
}
.newhead-box {
  img {
    width: 100%;
    // height: 184px;
  }
}
p {
  margin: 0;
  padding: 0;
}

.home-box {
  font-size: 18px;
  cursor: pointer;
  padding: 28px 24px 0 24px;
  //   margin-left: -20px;

  .head-box {
    width: 1640px;
    height: 240px;
    /*background: url("../assets/pcImages/1.1_Banner@2x.png") no-repeat;*/
    background-size: 100% 100%;
    padding-top: 142px;

    .head-btn1 {
      font-weight: 600;
      font-size: 16px;
      color: #ffffff;
      line-height: 44px;
      text-align: center;
      width: 144px;
      height: 44px;
      background: linear-gradient(312deg, #6c14ff 0%, #01fbf5 100%);
      border-radius: 8px;
      margin-right: 16px;
    }

    .head-btn2 {
      font-weight: 600;
      font-size: 16px;
      color: #08ecf6;
      line-height: 44px;
      text-align: center;
      width: 144px;
      height: 44px;
      border-radius: 8px !important;
      border: 1px solid;
    }
  }

  .my-works::-webkit-scrollbar {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
  }

  .my-works {
    box-sizing: border-box;
    /*padding: 0 24px 24px 24px;*/
    /*background: #ffffff;*/
    border-radius: 10px;
    // height: calc(100vh - 80px - 190px);
    height: calc(100vh - 80px - 20px);

    overflow-y: scroll;
    overflow-x: hidden;
    scrollbar-width: none !important; /* Firefox */
    -ms-overflow-style: none !important; /* IE 10+ */
    background: #1f1f1f;
    border-radius: 12px;
    // margin-top: 20px;
    padding-left: 24px;
    .select-box {
      padding: 15px 0;
      height: 150px;
      width: 100%;
      position: sticky;
      top: 0;
      z-index: 999;
      background: #1f1f1f;

      .pp1 {
        font-weight: 500;
        line-height: 60px;
        font-size: 16px;
        color: #eeeeee;
        margin-right: 16px;
      }

      .pp1-active {
        color: #01fbf5 !important;
      }

      .hs-box {
        width: 90px;
        height: 28px;
        background: #0e1126;
        border-radius: 6px;
        border: 1px solid rgba(255, 255, 255, 0.15);

        .normal {
          width: 44px;
          height: 24px;
          border-radius: 4px;
          text-align: center;
          font-weight: 400;
          font-size: 12px;
          color: #fafafaaa;
          line-height: 24px;
        }

        .hs-active {
          background: #6c14ff;
          border-radius: 4px;
          color: #ffffff;
        }
      }
    }

    .every-video-s {
      position: relative;
      margin: 0 36px 36px 0;
      width: 182px;
      height: 324px;
      border-radius: 16px;
      background-size: contain;
      background-position: center;
      border: 1px solid rgba(255, 255, 255, 0.15);
      .api-num1,
      .api-num2,
      .api-num3,
      .api-num-other {
        position: absolute;
        top: 8px;
        right: 8px;
        z-index: 9;
        min-width: 57px;
        height: 20px;
        background: #959494;
        border-radius: 4px;
        /*opacity: 0.3;*/
        font-weight: 400;
        font-size: 12px;
        color: #ffffff;
        line-height: 20px;
        text-align: center;
      }
      .api-num2 {
        background: #eaddad;
        opacity: 0.9;
        color: #604e10;
      }

      .api-num3 {
        background: #3afaf5;
        opacity: 0.9;
        color: #26415a;
      }

      .api-num-other {
        background: #6c14ff;
        opacity: 0.9;
        color: #e3d8f7;
      }
      // img {
      //   width: 243px;
      //   height: 432px;
      //   border-radius: 16px;
      // }
      .shengchenging {
        z-index: 9;
        position: absolute;
        width: 100%;
        height: calc(100% - 64px);
        border-radius: 16px 16px 0 0;
        top: 0;
        left: 0;
        background: rgba(42, 41, 41, 0.7);
        /*background: url('../assets/images/shengchengBg.jpg') no-repeat;*/
        /*background-size: 100% 100%;*/
        text-align: center;
        font-size: 14px;

        .desc-pp {
          padding-top: 200px;
        }

        img {
          position: absolute;
          top: 0;
          left: 0;
          /*padding-top: 280px;*/
          width: 100%;
          /*height: 40px;*/
        }

        .pt150 {
          padding-top: 120px;
        }
      }
      .video-hover {
        position: absolute;
        width: 100%;
        height: 48px;
        background: #1c1c1f;
        border-radius: 0px 0px 14px 14px;

        // left: 25px;
        // bottom: 30px;
        bottom: 0;
        padding: 6px 12px;

        .viode-hover-name {
          font-weight: 400;
          font-size: 12px;
          color: #ffffff;
        }
        .viode-hover-time {
          padding-top: 5px;
          font-weight: 400;
          font-size: 10px;
          color: rgba(255, 255, 255, 0.6);
        }
      }
      .video-pop {
        // .video-pop-select {
        //   height: 128px;
        //   background: #262626;
        //   display: flex;
        //   flex-direction: column;
        //   justify-content: space-around;
        //   align-items: center;
        //   .select-1 {
        //   }
        //   .select-2 {
        //   }
        //   .select-3 {
        //   }
        // }
        img {
          width: 16px;
          height: 16px;
        }
      }
      .head-btn1 {
        position: absolute;
        font-weight: 500;
        font-size: 12px;
        color: #ffffff;
        line-height: 28px;
        text-align: center;
        width: 96px;
        height: 28px;
        background: linear-gradient(312deg, #6c14ff 0%, #01fbf5 100%);
        border-radius: 4px;
        margin-right: 16px;
      }

      .btn1-top {
        left: 25px;
        bottom: 55px;
      }

      .btn2-top {
        left: 130px;
        bottom: 55px;
      }

      .pp3 {
        width: 243px;
        text-align: center;
        margin-top: 16px;
      }
    }

    // .every-video-s:nth-child(6n) {
    //   margin: 0 0 36px 0 !important;
    // }
  }
}
</style>
  <style>
.el-input__inner {
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
}
.home-box .el-input {
  /* width: 300px !important; */
}
.el-input-group__append {
  background-color: #1a1a1a !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  border-left: none !important;
}
.el-tabs__nav-wrap::after {
  background-color: transparent !important;
}
.el-tabs__item {
  font-weight: 400 !important;
  font-size: 16px !important;
  color: rgba(255, 255, 255, 0.6) !important;
}
.el-tabs__item:hover {
  font-weight: 500 !important;
  font-size: 16px !important;
  color: #ffffff !important;
}
.el-tabs__item.is-active {
  font-weight: 500 !important;
  font-size: 16px !important;
  color: #f7d274 !important;
  /* line-height: 22px; */
}
.el-tabs__active-bar {
  /* width: 28px !important; */
  background: linear-gradient(135deg, #f7d274 0%, #f5dfb5 100%) !important;
  border-radius: 2px !important;
}
</style>
  


// WEBPACK FOOTER //
// src/components/works.vue